export default "__VITE_ASSET__e5cda443__"